export const environment: any = {
    production: false,

    // AUTH
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REGISTER: '/auth/register',
    AUTH_CHECK: '/auth/check',
    NEW_REGISTER: '/data/api/register-user',
    LOGIN_WITH_GOOGLE: '/auth/api/google/authenticate',
    REGISTER_ACEDEMIC: '/data/api/register-academic',
    RESEND_OTP: '/data/api/register-user/resend-otp',
    VERIFY_OTP: '/data/api/register-user/verify-otp',
    COMPLETE_PROFILE: '/data/api/register-user/complete-profile',

    // PROFILE
    GET_PROFILE_DETAIL: '/data/me',
    CHANGE_PASSWORD: '/auth/change-pass',
    CHECK_PROFILE: '/auth/check-profile',
    RESET_PASSWORD: '/auth/api/reset-password',
    GET_LINK_RESET_PASSWORD: '/auth/api/forgot-password',

    // ORDERS
    ORDER_GET_ALL: '/data/api/orders/all',
    GET_PURCHASE_ORDER_LIST: '/data/api/orders',
    GET_PURCHASE_ORDER_DETAIL: '/data/api/orders/:id',
    CANCEL_PURCHASE_ORDER: '/data/api/orders/:id/cancel',

    // PACKETS
    PACKET_CREATE: '/data/api/packet/init',
    PACKET_GET_ALL: '/data/api/packet',
    PACKET_GET_BY_ID: '/data/api/packet/:id',
    GET_ALL_USER: '/auth/users',
    ADD_USER_TO_PACKET: '/data/api/packet-user/add',
    GET_PACKET_USERS: '/data/api/packet-user/:id',
    DELETE_PACKET_USERS: '/data/api/packet-user',
    GET_PACKET_API_LIST: '/data/api/packet/:code/apis',

    // API KEYS
    GET_API_KEYS_LIST: '/auth/api-keys',
    CREATE_API_KEY: '/auth/api-keys',
    DELETE_API_KEY: '/auth/api-keys/:id',
    UPDATE_API_KEY: '/auth/api-keys/:id',
    GET_API_KEY_DETAIL: '/auth/api-keys/:id/ip-whitelist',

    // PARTNERS
    PARTNER_CREATE: '/data/api/partners',
    PARTNER_GET_ALL: '/data/api/partners',
    PARTNER_GET_BY_ID: '/data/api/partners/:id',
    PARTNER_UPDATE_BY_ID: '/data/api/partners/:id',
    PARTNER_DELETE_BY_ID: '/data/api/partners/:id',

    // APIS
    API_CREATE: '/data/api/config/apis',
    API_GET_ALL: '/data/api/config/apis',
    API_GET_BY_ID: '/data/api/config/apis/:id',
    API_UPDATE_BY_ID: '/data/api/config/apis/:id',
    API_DELETE_BY_ID: '/data/api/config/apis/:id',

    // TEMPLATE CONFIG
    GET_PRICING_PAGE_CONFIG: '/data/api/config/pricing/info',
    UPDATE_PRICING_PAGE_CONFIG_EN: '/data/api/config/pricing/update/en',
    UPDATE_PRICING_PAGE_CONFIG_VI: '/data/api/config/pricing/update/vi',

    // POLICIES
    POLICY_CREATE: '/auth/policy-versions',
    POLICY_GET_ALL: '/auth/policy-versions',
    POLICY_GET_BY_ID: '/auth/policy-versions/:id',
    POLICY_UPDATE_BY_ID: '/auth/policy-versions/:id',
    POLICY_ACTIVATE_BY_ID: '/auth/policy-versions/:id/activate',
    POLICY_DELETE_BY_ID: '/auth/policy-versions/:id',
    POLICY_GET_ACTIVE: '/auth/policy-versions/active',
    POLICY_ACCEPT: '/auth/policy-versions/:id/accept',
    POLICY_ACCEPTANCES: '/auth/users/:id/policy-acceptances',

    // GENERAL
    GET_ALL_UNIVERSITY: '/auth/api/universities',
    POST_VENDOR_APPLICATION: '/data/api/vendor-application',
    POST_CUSTOM_DATA_REQUEST: '/data/api/custom-data-request',
    POST_GENERAL_INQUIRY: '/data/api/general-inquiry',
    POST_FEEDBACK: '/data/api/feedback',
    POST_FEEDBACK_COMPANY_DATA: '/data/api/feedback/company-data',
    SUBSCRIBE_EMAIL: '/data/subscribe',
    FILE_UPLOAD_PATH: '/attachments/api/files/upload',
    FORM_FILE_UPLOAD: '/data/form/upload',
    PARTNER_CONTACT: '/data/form/partner-contact',
    POST_RESEARCH_APPLY: '/data/form/research-apply',
    POST_PARTNER_APPLY: '/data/form/partner-apply',
    POST_COR3_APPLY: '/data/form/cor3-apply',
    POST_FACULTY_SCHOLAR: '/data/form/faculty-scholar',
    POST_PHD_FELLOW: '/data/form/phd-scholar',

    // DATASET GROUP
    DATASET_GROUP_CREATE: '/data/api/groups',
    DATASET_GROUP_GET_ALL: '/data/group/all',
    DATASET_GROUP_GET_FILTER: '/data/ds/info-filter',
    DATASET_GROUP_GET_BY_ID: '/data/api/groups/:id',

    // DATASET
    DATASET_CREATE: '/data/v2/ds/info',
    DATASET_GET_LIST_PENDING: '/data/pending',
    DATASET_GET_PENDING_BY_CODE: '/data/pending/:code',
    DATASET_GET_LIST_UPCOMING: '/data/api/v1/upcoming',
    DATASET_APPROVE: '/data/approve',
    DATASET_RELEASE: '/data/api/v1/release/:code',
    DATASET_GET_ALL: '/data/all',
    DATASET_GET_LIST_BY_GROUP_ID: '/data/group/:id',
    DATASET_GET_BY_CODE: '/data/ds/info',
    DATASET_GET_BY_ID: '/data/:id',
    DATASET_DELETE: '/data/v2/ds/info/:code',
    GET_FIELD_LIST: '/data/fields',
    DATASET_GET_FIELD_LIST_BY_ID: '/data/:id/fields',
    QUERY_DATASET: '/data/ds/search',
    GET_DATASET_PREVIEW: '/data/ds/preview',
    EXPORT_DATASET_REQUEST: '/data/export/request',
    EXPORT_DATASET_EVENTS: '/data/export/events/:jobId',
    EXPORT_DATASET_DOWNLOAD_ZIP: '/data/download/zip/:fileName',
    DATASET_UPDATE: '/data/v2/ds/info/:code',
    DATASET_IMPORT: '/data/v2/ds/import',
    DATASET_WATERMARK: '/data/watermark',
    UPLOAD_RECORD: '/data/v2/ds/upload-record',

    // CADASTRAL
    SEARCH_ADDRESS_TRIAL: '/data/administrative-units/trial/search',
    SEARCH_ADDRESS_V1: '/data/administrative-units/v1/paid/search',
    SEARCH_ADDRESS_V2: '/data/administrative-units/v2/paid/search',
    SEARCH_ADDRESS_BATCH: '/data/administrative-units/paid/search/batch',
    REPORT_ADDRESS: '/data/api/address-report',

    // COMPANY
    COMPANY_STATS_COUNT: '/company360/v2/stats/count',
    PROVINCE_GET_FILTER: '/data/administrative-units/provinces',
    INDUSTRY_GET_FILTER: '/data/company/industries',
    COUNTRY_GET_FILTER: '/data/company/countries',
    BUSINESS_GET_ALL: '/data/company/search',
    BUSINESS_GET_ALL_TRIAL: '/data/company/trial/search',
    BUSINESS_GET_BY_TAX_CODE: '/data/company/:taxCode/detail',
    BUSINESS_GET_BY_TAX_CODE_TRIAL: '/data/company/:taxCode/trial/detail',
    COMPANY_GRAPH_GET_BY_TAX_CODE: '/data/company/:taxCode/graph',
    COMPANY_GRAPH_GET_BY_TAX_CODE_TRIAL: '/data/company/:taxCode/trial/graph',
    COMPANY_GRAPH_GET_NODE_BY_ID: '/data/company/graph/expand',
    COMPANY_GRAPH_GET_NODE_BY_ID_TRIAL: '/data/company/graph/trial/expand',
    PINNED_COMPANY_GET_LIST: '/data/api/pinned-company/list',
    PINNED_COMPANY_TOGGLE: '/data/api/pinned-company/:taxCode/toggle',
    COMPANY_NEWS_ARTICLES: '/data/company/:taxCode/new-articles',
    COMPANY_NEWS_ARTICLES_TRIAL: '/data/company/:taxCode/trial/new-articles',
    COMPANY_KNOWLEDGE_CHAT: '/data/api/ai-company/ask',
    COMPANY_KNOWLEDGE_CHAT_TRIAL: '/data/api/ai-company/trial/ask',
    COMPANY_KNOWLEDGE_HISTORY: '/data/api/ai-company/history',
    COMPANY_DISCLOSURE_REQUEST: '/data/company/:taxCode/disclosure',
    COMPANY_DISCLOSURE_EVENTS: '/data/company/disclosure/events/:jobUuid',
    COMPANY_DISCLOSURE_JOBS: '/data/company/:taxCode/disclosure/jobs',
    COMPANY_DISCLOSURE_JOB_DETAIL: '/data/company/disclosure/jobs/:jobUuid',

    // EKYC
    GET_ALL_EKYC_OFFER: '/data/api/packet/pricing/ocr',

    // EMBEDDING
    GET_ALL_EMBEDDING_OFFER: '/data/api/packet/pricing/embedding',

    // DATA INSIGHTS
    DATA_INSIGHTS_GET_COMPANY_LIST: '/data/api/data-insight/companies',
    DATA_INSIGHTS_GET_SANKEY_GRAPH: '/data/api/data-insight/cash-flow/sankey',
    DATA_INSIGHTS_GET_SANKEY_GRAPH_TRIAL: '/data/api/data-insight/trial/cash-flow/sankey',
    DATA_INSIGHTS_GET_QUICK_INSIGHTS: '/data/api/data-insight/quick-insights',
    DATA_INSIGHTS_GET_QUICK_INSIGHTS_TRIAL: '/data/api/data-insight/trial/quick-insights',
    PINNED_SANKEY_COMPANY_GET_LIST: '/data/api/favourite-sankey-company/list',
    PINNED_SANKEY_COMPANY_TOGGLE: '/data/api/favourite-sankey-company/:taxCode/toggle',

    // PRICING
    LIST_PACKET: '/data/api/packet/pricing/dataset',
    PACKET_PAYMENT: '/data/api/payment/price/calculate',
    SAVE_INFOR_PAYMENT: '/data/api/orders',
    UPDATE_INFOR_PAYMENT: '/data/api/orders/:id',
    CREATE_PAYMENT: '/data/api/payment/create',
    GET_PAYMENT_DETAIL: '/data/api/payment/paypal/transaction',
    GET_LIST_PAYMENT_METHOD: '/data/api/payment/methods',
    GET_ORDER_NUMBER: '/data/api/payment/vnpay/transaction',

    /** STOMP user-specific queues (Spring-style destinations) */
    STOMP_USER_QUEUE_NOTIFICATIONS: '/user/queue/notifications',
    STOMP_USER_QUEUE_UNREAD_COUNT: '/user/queue/unread-count',

    // Keycloak
    KEYCLOAK_EXCHANGE_PATH: '/auth/internal/keycloak/exchange',

    // HPC (gateway route `hpc` → hpc-management-service)
    HPC_PUBLIC_PACKAGES: '/hpc/api/public/packages',
    // Personal HPC order (data-service); payment and order detail use the paths above
    CREATE_HPC_ORDER: '/data/api/orders/hpc',
    // Price, VAT and total of an HPC price tier (either audience) without creating the order
    HPC_ORDER_QUOTE: '/data/api/orders/hpc/quote',
    // Organization HPC order: the payment step creates it from the registration form, whose domain is checked first
    CREATE_HPC_ORG_ORDER: '/data/api/orders/hpc/org',
    CHECK_HPC_ORG_DOMAIN: '/data/api/orders/hpc/org/domain-check',

    // Notifications
    NOTIFICATION_GET_ALL: '/notification/msg',
    NOTIFICATION_GET_UNREAD_COUNT: '/notification/msg/unread-count',
    NOTIFICATION_READ_ALL: '/notification/msg/read-all',
    NOTIFICATION_READ_ONE: '/notification/msg/:id/read',
};
